import React from 'react';
import Select from 'react-select';
import { injectIntl, intlShape } from 'react-intl';
import { oneOf, string, node, arrayOf, object, objectOf } from 'prop-types';
import CustomControl from '../CustomControl/CustomControl';
import cn from 'classnames';

const getString = (intl, id, defaultMessage) => intl.formatMessage({ id, defaultMessage });

const propTypes = {
  intl: intlShape.isRequired,
  id: string.isRequired,
  inputType: oneOf(['text', 'number', 'select', 'input-form']),
  children: node,
  options: arrayOf(object),
  placeholder: object,
};

const defaultProps = {
  intl: () => {},
};

const FeaturesListItemControl = ({
  inputType,
  id,
  children,
  options,
  placeholder,
  intl,
  ...params
}) => {
  if (inputType) {
    if (inputType === 'select') {
      return (
        <>
          {children && (
            <label htmlFor={id} className="features-control-label mt-2">
              {children}
            </label>
          )}
          <Select
            id={id}
            placeholder={getString(intl, placeholder.id, placeholder.defaultMessage)}
            options={options.map(({ title, defaultTitle, id: value }) => ({
              value,
              label: getString(intl, title, defaultTitle),
            }))}
            clearable={false}
            {...params}
            className="features-control features-control--select Select--sm"
          />
        </>
      );
    }
    if (inputType === 'input-form') {
      return (
        <div className="features-control-text-input-wrapper">
          {children && (
            <label htmlFor={id} className="features-control-label">
              {children}
            </label>
          )}
          <input
            type="text"
            id={id}
            {...params}
            className={cn("features-control-text-input form-control", {'mt-2': !children})}
          />
        </div>
      );
    }
    return (
      <div className="features-contol">
        <label htmlFor={id} className="features-control-label">
          {children}
        </label>
        <input
          type={inputType}
          id={id}
          {...params}
          className="features-control-input form-control"
        />
      </div>
    );
  }

  return (
    <CustomControl id={id} {...params}>
      {children}
    </CustomControl>
  );
};

FeaturesListItemControl.propTypes = propTypes;
FeaturesListItemControl.defaultProps = defaultProps;

export default injectIntl(FeaturesListItemControl);
